import envs from '@/constants/envs'

export function castrationUrl(castration) {
  return `${envs.REACT_APP_BASE_WEB_SHOW_URL}/castration/${castration?.uid}`
}
